/**
 * 运价梯度显示组件
 */

import React from 'react';

interface RateTierDisplayProps {
    channelRateInfo: {
        name: string;
        tiers: any[];
        matchedRate: number;
    };
    chargeableWeight: number;
}

export const RateTierDisplay: React.FC<RateTierDisplayProps> = ({
    channelRateInfo,
    chargeableWeight
}) => {
    return (
        <div style={{
            marginTop: -8,
            marginBottom: 12,
            padding: '6px 8px',
            background: 'linear-gradient(135deg, #f0f5ff 0%, #e6f7ff 100%)',
            border: '1px solid #91d5ff',
            borderRadius: 4,
            fontSize: 11
        }}>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: 4
            }}>
                <span style={{ fontWeight: 600, color: '#1890ff', fontSize: 12 }}>
                    运价梯度
                </span>
                <span style={{ color: '#52c41a', fontSize: 11, fontWeight: 600 }}>
                    {chargeableWeight.toFixed(2)}kg → ¥{channelRateInfo.matchedRate}/kg
                </span>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                {channelRateInfo.tiers.map((tier: any, idx: number) => {
                    const isMatched = tier.price_per_kg === channelRateInfo.matchedRate;
                    return (
                        <div key={idx} style={{
                            padding: '2px 8px',
                            background: isMatched ? '#1890ff' : '#fff',
                            color: isMatched ? '#fff' : '#666',
                            border: isMatched ? 'none' : '1px solid #d9d9d9',
                            borderRadius: 3,
                            fontSize: 10,
                            fontWeight: isMatched ? 600 : 400,
                            whiteSpace: 'nowrap'
                        }}>
                            {tier.min_weight ? `${tier.min_weight}+kg` : '起步'}: ¥{tier.price_per_kg}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};
